// Central site configuration — replace contact details here once available.
export const SITE = {
  name: "Eco Ready Solutions, LLC",
  slogan: "Let's Be Clean Together",
  address: "220 S Main St, Royal Oak, MI 48067",
  phone: "(248) 247-5377",
  phoneHref: "tel:+12482475377",
  email: "info@ecoreadysolutions.com",
  emailHref: "mailto:info@ecoreadysolutions.com",
  website: "www.ecoreadysolutions.com",
  websiteHref: "https://www.ecoreadysolutions.com",
  hours: "Mon–Fri 8:00am – 6:00pm  ·  Sat 10:00am – 3:00pm",
  serviceArea: "Metro Detroit, Oakland County, and surrounding areas",
  experience: "30+ years of professional cleaning experience",
  startingPrice: "$0.12 per square foot",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/pricing", label: "Pricing" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];
